import { Component, Input } from '@angular/core';

@Component({
  selector: 'ng-casto-img-loader',
  templateUrl: './image-loader.component.html',
})
export class ImageLoaderComponent {
  @Input() imgSrc: string;
  @Input() spinnerSrc: string = 'assets/img/placeholders/loading.gif';
  @Input() imgClass: string;
  @Input() imgAlt: string = '';

  loading: boolean = true;

  constructor() {}

  onLoad() {
    this.loading = false;
  }

}
